/**
 * 船上 `config/` 三個檔（`admin.release_manifest` 權限）。
 *
 * ATTRACTION_* 兩個檔由景點資料產生，CHECK_CONFIG.TXT 是整份文字貼上。前端只負責
 * 顯示與切換，格式與警告都由後端算——那兩件事必須與發布用的是同一份邏輯。
 */

import { apiFetch, type Schemas } from './core';

export type DisplayConfigFile = Schemas['ConfigFileResponseDto'];

export type ConfigSource = 'generated' | 'manual';

/** 檔名是船機韌體寫死的，不能新增。 */
export const CONFIG_FILENAMES = [
  'CHECK_CONFIG.TXT',
  'ATTRACTION_LOCATION.TXT',
  'ATTRACTION_NANE.TXT',
  'asr_keywords_dynamic.json',
] as const;

export type ConfigFilename = (typeof CONFIG_FILENAMES)[number];

/** 每個檔的用途說明——看這一頁的人多半不知道這三個是幹嘛的。 */
export const CONFIG_FILE_HINT: Record<ConfigFilename, string> = {
  'CHECK_CONFIG.TXT':
    '船機主設定：視野角、觸發距離、語言索引、GPS／AHRS 序列埠等。改錯會讓整台船機的導覽行為異常。',
  'ATTRACTION_LOCATION.TXT': '各景點的座標，每行為「景點編號,緯度,經度」，六位小數。',
  'ATTRACTION_NANE.TXT':
    '各景點的名稱，每行為「景點編號,中文,英文,日文」。檔名的拼字是規格書原文。',
  'asr_keywords_dynamic.json':
    '語音辨識詞表（船上 data/）。店家清單由各景點的推薦點產生，全域分類與控制項的諧音字沿用下方底稿——請貼上廠商提供的整份 JSON。',
};

export function listDisplayConfigFiles(): Promise<DisplayConfigFile[]> {
  return apiFetch<DisplayConfigFile[]>('/admin/display-config-files', { method: 'GET' });
}

export function updateDisplayConfigFile(
  filename: ConfigFilename,
  patch: { content?: string; line_ending?: 'crlf' | 'lf'; source?: ConfigSource },
): Promise<DisplayConfigFile> {
  return apiFetch<DisplayConfigFile>(`/admin/display-config-files/${filename}`, {
    method: 'PUT',
    body: patch,
  });
}
